import html2canvas from 'html2canvas'

export const imageUrlReader = async (urls, type = 'blobUrl', maxWidth, maxHeight) => {
  if (!urls) {
    return
  }
  const getContent = url => new Promise(resolve => {
    let img = new Image()
    img.onload = e => {
      let canvas = document.createElement('canvas')
      let targetWidth = img.width
      let targetHeight = img.height
      maxWidth = maxWidth || img.width
      maxHeight = maxHeight || img.height
      if (targetWidth > maxWidth || targetHeight > maxHeight) {
        if (targetWidth / targetHeight > maxWidth / maxHeight) {
          targetHeight = Math.round(maxWidth * (targetHeight / targetWidth))
          targetWidth = maxWidth
        } else {
          targetHeight = maxHeight
          targetWidth = Math.round(maxHeight * (targetWidth / targetHeight))
        }
      }
      canvas.width = targetWidth
      canvas.height = targetHeight
      canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight)
      canvas.toBlob(blob => {
        if (type === 'blobUrl') {
          resolve(URL.createObjectURL(blob))
        } else if (type === 'blob') {
          resolve(blob)
        }
      })
    }
    img.setAttribute('crossOrigin', 'Anonymous')
    img.src = url
  })
  let content = []
  for (let url of urls) {
    content.push(await getContent(url))
  }
  return content
}

export const imageReader = async (files, type = 'dataUrl', maxWidth, maxHeight) => {
  if (!files) {
    return
  }
  const getContent = file => new Promise(resolve => {
    let reader = new FileReader()
    reader.onload = async e => {
      let dataUrl = e.target.result.startsWith('data:image/') ? e.target.result : ''
      if (maxWidth || maxHeight || type === 'blob' || type === 'blobUrl') {
        resolve(await imageUrlReader([dataUrl], type === 'dataUrl' ? 'blobUrl' : type, maxWidth, maxHeight))
      } else if (type === 'dataUrl') {
        resolve(dataUrl)
      } else {
        resolve('')
      }
    }
    reader.readAsDataURL(file)
  })
  let content = []
  for (let file of files) {
    content.push(await getContent(file))
  }
  return content
}

export const sortData = (arr, keys, orders) => {
  if (!arr || !(arr instanceof Array)) {
    return arr
  }
  if (keys instanceof Object && !(keys instanceof Array) && !(keys instanceof Function)) {
    return arr
  }
  keys = keys instanceof Array ? keys : [keys]
  orders = orders instanceof Array ? orders : [orders]
  if (keys.length <= 0) {
    return arr
  }
  const sortBy = (keys, orders) => (o1, o2) => {
    let key = keys[0]
    let order = orders[0] !== 'desc' ? 1 : -1
    let co1 = key instanceof Function ? key(o1) : o1[key]
    let co2 = key instanceof Function ? key(o2) : o2[key]
    co1 = co1 instanceof Array ? co1.length : co1
    co2 = co2 instanceof Array ? co2.length : co2
    if (co1 === null || co1 === undefined || co1 < co2) {
      return -1 * order
    } else if (co2 === null || co2 === undefined || co1 > co2) {
      return 1 * order
    } else {
      return keys.length === 0 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2)
    }
  }
  return [...arr].sort(sortBy(keys, orders))
}

export const dateFormat = (date, fmt) => {
  date.setHours(date.getHours() - (date.getTimezoneOffset() - (new Date()).getTimezoneOffset()) / 60)
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export const toFormdata = (object, needEmpty = false) => {
  let formData = new FormData()
  for (let kv of Object.entries(object)) {
    if (needEmpty || (kv[1] !== null && kv[1] !== undefined)) {
      if (kv[1] instanceof Array) {
        for (let data of kv[1]) {
          formData.append(kv[0] + '[]', data)
        }
      } else {
        formData.append(kv[0], kv[1])
      }
    }
  }
  return formData
}

export const groupBy = (ary, f, needKey = false) => {
  let groups = {}
  for (let item of ary) {
    let key = JSON.stringify(f(item))
    if (key) {
      groups[key] = groups[key] || []
      groups[key].push(item)
    }
  }
  return needKey ? groups : Object.values(groups)
}

export const toPriceString = price => {
  return (price + '').split('.').map(s => s.replace(/(?!^)(?=(\d{3})+($|\.))/g, ',')).join('.')
}

export const downloadFile = (fileName, urlData, target) => {
  let aLink = document.createElement('a')
  if (fileName) {
    aLink.download = fileName
  }
  if (target) {
    aLink.target = target
  }
  aLink.href = urlData
  aLink.click()
}

export const convolve = (imageData, kernel, amount) => {
  const pixelData = imageData.data
  const imageWidth = imageData.width
  const imageHeight = imageData.height
  const output = new ImageData(
    new Uint8ClampedArray(imageData.data),
    imageData.width,
    imageData.height
  )
  const side = Math.sqrt(kernel.length)
  const half = Math.floor(side / 2)
  const outputPixelData = output.data
  for (let y = 0; y < imageHeight; y++) {
    for (let x = 0; x < imageWidth; x++) {
      const dstOff = (y * imageWidth + x) * 4
      let totalR = 0
      let totalG = 0
      let totalB = 0
      for (let row = 0; row < side; row++) {
        for (let col = 0; col < side; col++) {
          const srcY = y + row - half
          const srcX = x + col - half
          if (srcY < 0 || srcY > imageHeight || srcX < 0 || srcX > imageWidth) {
            continue
          }
          const srcOff = (srcY * imageWidth + srcX) * 4
          const weight = kernel[row * side + col]
          const [r, g, b] = [
            pixelData[srcOff],
            pixelData[srcOff + 1],
            pixelData[srcOff + 2]
          ]
          totalR += r * weight
          totalG += g * weight
          totalB += b * weight
        }
      }
      if (amount || amount === 0) {
        outputPixelData[dstOff] = totalR * amount + outputPixelData[dstOff] * (1 - amount)
        outputPixelData[dstOff + 1] = totalG * amount + outputPixelData[dstOff + 1] * (1 - amount)
        outputPixelData[dstOff + 2] = totalB * amount + outputPixelData[dstOff + 2] * (1 - amount)
      } else {
        outputPixelData[dstOff] = totalR
        outputPixelData[dstOff + 1] = totalG
        outputPixelData[dstOff + 2] = totalB
      }
    }
  }
  return output
}

export const html2DataUrl = async (content, mime = 'png', amount = 0) => {
  let width = content.offsetWidth
  let height = content.offsetHeight
  let customCanvas = document.createElement('canvas')
  let scale = 2
  customCanvas.width = width * scale
  customCanvas.height = height * scale
  customCanvas.getContext('2d').scale(scale, scale)
  let options = {
    scale: scale,
    canvas: customCanvas,
    width: width,
    height: height,
    backgroundColor: null,
    useCORS: true
  }
  let canvas = await html2canvas(content, options)
  let context = canvas.getContext('2d')
  context.mozImageSmoothingEnabled = false
  context.webkitImageSmoothingEnabled = false
  context.msImageSmoothingEnabled = false
  context.imageSmoothingEnabled = false
  let imageData = context.getImageData(0, 0, canvas.width, canvas.height)
  imageData = convolve(imageData, [-1, -1, -1, -1, 9, -1, -1, -1, -1], amount)
  context.putImageData(imageData, 0, 0)
  let pageData = canvas.toDataURL('image/' + mime, 1.0)
  return pageData
}

export const nco = (operation, _default) => {
  try {
    let result = operation()
    return result !== null && result !== undefined ? result : _default
  } catch (e) {
    return _default
  }
}

export const convertFileSize = (_byte) => {
  const sizeType = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y', 'B', 'Ge']
  let type = 0
  for (; _byte > 1024 || type === sizeType.length; _byte /= 1024, type++) {}
  return Math.round(_byte) + sizeType[type] + 'B'
}

export const fileTypeCheck = (e, operation, onError) => {
  let acceptTypes = e.target.getAttribute('accept')
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null
  let extension = e.target.getAttribute('extension')
  extension = extension ? extension.split(',') : null
  let match = (arys, s) => {
    for (let ary of arys) {
      let rgx = new RegExp(ary)
      if (rgx.test(s)) {
        return true
      }
    }
    return false
  }
  for (let file of e.target.files) {
    let fileType = file.type
    let fileExtension = file.name.split('.')
    fileExtension = fileExtension[fileExtension.length - 1]
    if (extension && !match(extension, fileExtension)) {
      e.target.value = ''
      if (onError) {
        onError(e, extension)
      }
      return
    }
    if (acceptTypes && !match(acceptTypes, fileType)) {
      e.target.value = ''
      if (onError) {
        onError(e, acceptTypes)
      }
      return
    }
  }
  operation(e)
}

export const dataUrlToBlobUrl = dataUrl => {
  let arr = dataUrl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return URL.createObjectURL(new Blob([u8arr], { type: mime }))
}

export const htmlDecode = input => {
  let e = document.createElement('div')
  e.innerHTML = input
  return e.childNodes[0].nodeValue
}

export const toDivideNumber = (number, base, reverse = false) => {
  const isNormal = (!reverse && number >= 0) || (reverse && number < 0)
  return number + (isNormal ? (base - Math.abs(number) % base) : (-Math.abs(number) % base)) * (number >= 0 ? 1 : -1)
}

export const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d)
}



// WEBPACK FOOTER //
// ./src/constants/global/util.js